import { DOT } from '../utils/symbols.js';

/** Odoo module tiles shared by desktop canvas and mobile chip list. */
export const ODOO_MODULE_TILES = [
  { key: 'crm', label: 'CRM', desc: `Pipeline ${DOT} Leads`, color: '#38AECC' },
  { key: 'acc', label: 'Accounting', desc: `VAT ${DOT} Journals`, color: '#017E84' },
  { key: 'inv', label: 'Inventory', desc: 'Multi-warehouse', color: '#714B67' },
  { key: 'mfg', label: 'Manufacturing', desc: `MRP ${DOT} Routing`, color: '#38AECC' },
  { key: 'sales', label: 'Sales', desc: 'Quote to Order', color: '#0047AB' },
  { key: 'web', label: 'Website', desc: `CMS ${DOT} SEO`, color: '#38AECC' },
  { key: 'ec', label: 'eCommerce', desc: `Storefront ${DOT} POS`, color: '#E42613' },
  { key: 'hr', label: 'HR', desc: `WPS ${DOT} Payroll AE`, color: '#714B67' },
  { key: 'mkt', label: 'Marketing', desc: 'Campaigns', color: '#38AECC' },
  { key: 'proj', label: 'Projects', desc: `Time ${DOT} Tasks`, color: '#0047AB' },
  { key: 'pos', label: 'Point of Sale', desc: `iPad ${DOT} Offline`, color: '#38AECC' },
];

export const ODOO_MODULE_LINKS = [
  { from: 'mkt', to: 'web', label: 'Campaign traffic' },
  { from: 'web', to: 'crm', label: 'Forms create leads' },
  { from: 'mkt', to: 'crm', label: 'Nurtured leads' },
  { from: 'crm', to: 'sales', label: 'Opportunity to quote' },
  { from: 'sales', to: 'acc', label: 'Customer invoice' },
  { from: 'sales', to: 'inv', label: 'Delivery order' },
  { from: 'inv', to: 'mfg', label: 'Component availability' },
  { from: 'mfg', to: 'inv', label: 'Finished goods receipt' },
  { from: 'web', to: 'ec', label: 'Shop pages' },
  { from: 'ec', to: 'sales', label: 'Sales order' },
  { from: 'ec', to: 'inv', label: 'Stock reservation' },
  { from: 'pos', to: 'inv', label: 'Real-time stock moves', route: 'pos-inv' },
  { from: 'pos', to: 'acc', label: 'POS session posting', route: 'pos-acc' },
  { from: 'sales', to: 'proj', label: 'Service project' },
  { from: 'proj', to: 'acc', label: 'Timesheets to invoice' },
  { from: 'hr', to: 'acc', label: 'Payroll journal' },
];

const ODOO_CANVAS_LAYOUT_DESKTOP = [
  { x: '30%', y: '18%', size: 'xl' },
  { x: '70%', y: '14%', size: 'lg' },
  { x: '85%', y: '34%', size: 'md' },
  { x: '80%', y: '58%', size: 'lg' },
  { x: '58%', y: '42%', size: 'xl' },
  { x: '14%', y: '40%', size: 'md' },
  { x: '40%', y: '66%', size: 'lg' },
  { x: '18%', y: '70%', size: 'md' },
  { x: '62%', y: '78%', size: 'md' },
  { x: '90%', y: '80%', size: 'sm' },
  { x: '24%', y: '52%', size: 'sm' },
];

/** Spread modules across the full canvas on narrow screens. */
export const ODOO_CANVAS_LAYOUT_COMPACT = [
  { x: '24%', y: '19%', size: 'lg' },
  { x: '76%', y: '18%', size: 'md' },
  { x: '87%', y: '37%', size: 'sm' },
  { x: '78%', y: '58%', size: 'md' },
  { x: '50%', y: '35%', size: 'lg' },
  { x: '12%', y: '33%', size: 'sm' },
  { x: '32%', y: '57%', size: 'md' },
  { x: '12%', y: '65%', size: 'sm' },
  { x: '54%', y: '69%', size: 'sm' },
  { x: '76%', y: '77%', size: 'sm' },
  { x: '16%', y: '47%', size: 'sm' },
];

/** Phone canvas layout keeps the same diagram legible without swapping components. */
export const ODOO_CANVAS_LAYOUT_PHONE = [
  { x: '26%', y: '17%', size: 'lg' },
  { x: '76%', y: '18%', size: 'md' },
  { x: '92%', y: '43%', size: 'sm' },
  { x: '72%', y: '63%', size: 'md' },
  { x: '50%', y: '38%', size: 'lg' },
  { x: '10%', y: '43%', size: 'sm' },
  { x: '33%', y: '75%', size: 'md' },
  { x: '10%', y: '82%', size: 'sm' },
  { x: '55%', y: '84%', size: 'sm' },
  { x: '91%', y: '79%', size: 'sm' },
  { x: '27%', y: '55%', size: 'sm' },
];

/** Desktop canvas layout: positions are percentage-based on 1280x720. */
export const ODOO_CANVAS_MODULES = ODOO_MODULE_TILES.map((tile, i) => ({
  ...tile,
  ...ODOO_CANVAS_LAYOUT_DESKTOP[i],
}));
